<template>
  <ValidationObserver ref="observer">
    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="font-weight-bold text-dark">View Employee Feedback</h2>
        </b-col>
      </b-row>
      <b-card>
        <b-card-body>
          <b-row>
            <b-col>
              <h5 class="text-primary d-inline">Name :</h5>
              <p class="d-inline ml-1">
                {{ survey[0] && survey[0].name && survey[0].name.first }}
                {{ survey[0] && survey[0].name && survey[0].name.last }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-for="(question, index) in survey"
              :key="index"
              cols="12"
              md="6"
              v-if="question.questionId"
            >
              <h5 v-if="question.questionId.text">
                {{ "Question" }} :
                {{ question.questionId.text || "-" }}
              </h5>
              <p v-if="question.questionId">
                {{ "Answer" }} :
                {{
                  question.questionId.type === "MCQ"
                    ? (question.questionId.options[question.submittedAnswer] &&
                        question.questionId.options[question.submittedAnswer].text) ||
                      "-"
                    : question.submittedAnswer || "-"
                }}
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <c-input
                inputType="text"
                :inputId="'reward'"
                :lableText="'Add Reward Balance *'"
                v-model="reward"
              />
            </b-col>
          </b-row>
          <b-row class="justify-content-center mt-4">
            <b-col cols="auto">
              <b-button variant="secondary" @click="cancelSurvey">Back</b-button>
            </b-col>
            <b-col cols="auto">
              <b-button type="submit" variant="success" @click="handleSubmit"
                >Submit</b-button
              >
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-container>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";

export default {
  name: "ViewSurvey",
  components: {
    cInput,
    ValidationObserver,
  },
  data() {
    return {
      reward: "",
      survey: {
        _id: "",
        createdBy: "",
        status: "",
        createdAt: "",
        questions: [
          {
            text: "",
            type: "",
            answer: "",
          },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      const payload = {
        user: this.$route?.params?.feedbackId,
        tenant: this.$currentUserData._id,
        point: +this.reward,
        amountType: { key: "1104001", value: "REWARD" },
        transactionRef: "REWARD",
        expireAt: null,
      };
      this.$store.dispatch("survey/addRewards", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Reward has been added successfully!!",
          type: "success",
        });
        this.$router.push("/feedback");
      });
    },
    getFeedBackDetails() {
      const payload = {
        id: this.$route?.params?.id || "",
        userId: this.$route?.params?.feedbackId || "",
      };
      this.$store.dispatch("survey/employeeFeedbackDetails", payload).then((response) => {
        this.survey = response.data;
      });
    },
    cancelSurvey() {
      this.$router.push("/feedback");
    },
  },
  mounted() {
    this.getFeedBackDetails();
  },
};
</script>

<style scoped>
.text-primary {
  color: #007bff !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.text-dark {
  color: #343a40 !important;
}
</style>
